/** @jsx jsx */
import { css, jsx } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { media } from '@atlaskit/primitives/responsive';

const dividerStyles = css({
	border: 0,
	borderBottom: `1px solid ${token('color.border')}`,

	[media.below.lg]: {
		marginBlock: token('space.075'),
	},
	[media.above.lg]: {
		marginBlock: token('space.100'),
	},
});

export const Divider = () => <hr role="presentation" css={dividerStyles} />;
